// src/pages/About/About.js
import React from 'react';
import './About.scss';

// Import images (you'll need to add these to your project)
import teamImage1 from '../../assets/images/team-member1.jpg';
import officeImage from '../../assets/images/office1.jpg';

const About = () => {
  return (
    <div className="about-page">
      {/* Hero Section */}
      <section className="about-hero">
        <div className="container">
          <h1>About Simak</h1>
          <p className="hero-description">
            We are a dedicated team of professionals committed to transforming organizations through comprehensive  
            IS mapping, Geo-Spatial Data Analysis, Socio-Economic Survey, Monitoring and Evaluation of Projects, 
            DMS services and IT-enabled solutions that transform 
          organizations.
          </p>
        </div>
      </section>

      {/* Mission Section */}
      <section className="mission-section">
        <div className="container">
          <div className="mission-content">
            <h2>Our Mission</h2>
            <p>
              To empower organizations with cutting-edge technology solutions that streamline operations, enhance productivity, and drive sustainable growth. We are committed to delivering exceptional value through comprehensive DMS services, IT-enabled solutions, GIS mapping, economic analysis, and monitoring & evaluation services.
            </p>
          </div>
          <div className="vision-content">
            <h2>Our Vision</h2>
            <p>
              To be the leading provider of integrated technology solutions, recognized for our innovation, reliability, and exceptional client service. We envision a future where every organization can leverage the full potential of technology to achieve their goals and create lasting impact in their communities.
            </p>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      {/* <section className="stats-section">
        <div className="container">
          <div className="stats-grid">
            <div className="stat-item">
              <h3>500+</h3>
              <p>Projects Completed</p>
            </div>
            <div className="stat-item">
              <h3>5+</h3>
              <p>Years of Excellence</p>
            </div>
          </div>
        </div>
      </section> */}

      {/* Values Section */}
      <section className="values-section">
        <div className="container">
          <h2>Our Core Values</h2>
          <p className="values-intro">
            These values guide our decisions, shape our culture, and drive our commitment to excellence.
          </p>
          
          <div className="values-grid">
            <div className="value-card">
              <h3>Excellence</h3>
              <p>We strive for excellence in every project, delivering solutions that exceed expectations and drive real business value.</p>
            </div>
            <div className="value-card">
              <h3>Collaboration</h3>
              <p>We believe in the power of teamwork, both within our organization and in partnership with our clients.</p>
            </div>
            <div className="value-card">
              <h3>Innovation</h3>
              <p>We stay at the forefront of technology, continuously exploring new ways to solve complex business challenges.</p>
            </div>
            <div className="value-card">
              <h3>Transparency</h3>
              <p>We maintain open communication and honest relationships with our clients, ensuring clarity throughout every project.</p>
            </div>
          </div>
        </div>
      </section>

{/* Team Section */}
<section className="team-section">
  <div className="container">
    <h2>Director's Room</h2>
    <p className="team-intro">
      Our diverse team leverages decades of combined experience at the intersection of technology, 
      business, and client service. We don't just understand these domains in isolation; we integrate them to 
      deliver tailored solutions that drive tangible results and ensure your success.
    </p>
    
    <div className="team-grid">
      <div className="team-member">
        <div className="member-image">
          <img src={teamImage1} alt="Javed Shaikh" />
        </div>
        <div className="member-info">
          <h3>Javed A. Shaikh</h3>
          <p className="position">CEO & Director</p>
          <p className="expertise">GIS Development, Spatial Analysis</p>
        </div>
      </div>
    </div>
  </div>
</section>

      {/* Office Section */}
      <section className="office-section">
        <div className="container">
          <div className="office-content">
            <div className="office-text">
              <h2>Our Office</h2>
              <p>
                Our headquarters in the central business district is more than an office—it's a 
                collaborative hub designed for innovation. Come see for yourself how our environment drives results.
              </p>
              <div className="office-details">
                <h4>Address</h4>
                <p>SIMAK IT Private Limited, 3rd Floor, Datta Palace, Gandhi Chowk Amravati,<br/> Maharashtra, India.</p><br></br>
                <h4>Office Hours</h4>
                <p>Monday - Saturday: 10:00 AM - 6:00 PM</p>
              </div>
            </div>
            <div className="office-image">
              <img src={officeImage} alt="Simak Office" />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;